import { render, staticRenderFns } from "./video-list-page.vue?vue&type=template&id=079c6338&scoped=true&"
import script from "./video-list-page.vue?vue&type=script&lang=js&"
export * from "./video-list-page.vue?vue&type=script&lang=js&"
import style0 from "./video-list-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./video-list-page.vue?vue&type=style&index=1&id=079c6338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c6338",
  null
  
)

export default component.exports